import type { CorrelationResult } from '../../utils/correlation'

type CorrelationSummaryProps = {
  correlations: CorrelationResult
}

export function CorrelationSummary({ correlations }: CorrelationSummaryProps) {
  const { closestPair, mostDifferentPair } = correlations

  if (!closestPair && !mostDifferentPair) {
    return (
      <div className="p-4 border border-black/10 rounded-lg bg-white">
        <h3 className="font-medium mb-2">Taster Correlation</h3>
        <p className="text-black/60 text-sm">
          Not enough data. Need at least 2 tasters with complete scores.
        </p>
      </div>
    )
  }

  return (
    <div className="p-4 border border-black/10 rounded-lg bg-white space-y-4">
      {closestPair && (
        <div>
          <h3 className="text-sm font-medium text-black/60 uppercase tracking-wide">
            Closest Match
          </h3>
          <div className="mt-1">
            <span className="font-medium">
              {closestPair.tasterA} & {closestPair.tasterB}
            </span>
            <span className="ml-2 text-black/60">ρ = {closestPair.correlation.toFixed(2)}</span>
          </div>
        </div>
      )}

      {mostDifferentPair && (
        <div>
          <h3 className="text-sm font-medium text-black/60 uppercase tracking-wide">
            Most Different
          </h3>
          <div className="mt-1">
            <span className="font-medium">
              {mostDifferentPair.tasterA} & {mostDifferentPair.tasterB}
            </span>
            <span className="ml-2 text-black/60">
              ρ = {mostDifferentPair.correlation.toFixed(2)}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}
